import React from 'react';

function ErrorDisplay({ error, onRetry }) {
  return (
    <div className="min-h-screen bg-surface-950 p-6 flex items-center justify-center">
      <div className="bg-surface-850 border border-line rounded-xl p-8 max-w-md w-full">
        <div className="flex items-center justify-center w-12 h-12 bg-red-600/20 rounded-full mb-4 mx-auto">
          <svg className="w-6 h-6 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <h3 className="text-red-400 text-xl font-bold mb-2 text-center">Something went wrong</h3>
        <p className="text-gray-300 text-center mb-6">{error}</p>
        {onRetry && (
          <button 
            onClick={onRetry}
            className="w-full px-4 py-3 bg-accent hover:bg-accent-hover text-white rounded-lg transition-colors duration-150 font-medium flex items-center justify-center gap-2 group"
          >
            <svg className="w-4 h-4 group-hover:rotate-180 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
            Try Again
          </button>
        )}
      </div>
    </div>
  );
}

export default ErrorDisplay;